var render, staticRenderFns
import script from "./revenuesPerPeriod.vue?vue&type=script&lang=js&"
export * from "./revenuesPerPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a158c8f8",
  null
  
)

export default component.exports